import { getInstagramMediaKind } from 'src/utils/instagramMediaLimits';

// ----------------------------------------------------------------------
// Tipos de mídia suportados pelo editor de pré-visualização (estilo WhatsApp Web)

export function getMediaKind(file) {
    const type = file?.type || '';
    if (type.startsWith('image/')) return 'image';
    if (type.startsWith('video/')) return 'video';
    if (type === 'application/pdf') return 'pdf';
    if (type.startsWith('audio/')) return 'audio';
    // Demais tipos (xlsx, docx, html, txt, zip...) entram como documento genérico
    return 'file';
}

// Documentos sempre vão como isDocument; só imagem/vídeo têm envio "de mídia"
export function isDocumentKind(kind) {
    return kind === 'pdf' || kind === 'file';
}

export function isEditorSupported(files, canal) {
    if (!files || files.length === 0) return false;
    return files.every((file) => {
        const kind = getMediaKind(file);
        // Áudio segue no fluxo legado (gravação/envio próprios)
        if (kind === 'audio') return false;
        // Instagram: o editor cobre só imagem/vídeo (PDF vai pelo dialog legado);
        // usa a mesma regra de formato das travas de envio (getInstagramMediaKind).
        if (canal === 'instagram') {
            const igKind = getInstagramMediaKind(file);
            return igKind === 'image' || igKind === 'video';
        }
        return true;
    });
}

const FILE_ICONS = [
    { exts: ['pdf'], icon: 'mdi:file-pdf-box', color: 'text-red-500' },
    { exts: ['xls', 'xlsx', 'csv'], icon: 'mdi:file-excel', color: 'text-green-600' },
    { exts: ['doc', 'docx'], icon: 'mdi:file-word', color: 'text-blue-600' },
    { exts: ['ppt', 'pptx'], icon: 'mdi:file-powerpoint', color: 'text-orange-500' },
    { exts: ['txt', 'md', 'rtf'], icon: 'mdi:file-document-outline', color: 'text-gray-500' },
    { exts: ['html', 'htm'], icon: 'mdi:language-html5', color: 'text-orange-600' },
    { exts: ['zip', 'rar', '7z'], icon: 'mdi:folder-zip', color: 'text-amber-600' },
];

export function getFileIcon(file) {
    const ext = (file?.name || '').split('.').pop()?.toLowerCase();
    const match = FILE_ICONS.find((entry) => entry.exts.includes(ext));
    return match || { icon: 'mdi:file-outline', color: 'text-gray-500' };
}
